
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33821',
  depVersions: {
  "documents-public-ui": "static-1.33821",
  "client-types": "static-1.443",
  "documents-lib": "static-1.33826",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1850",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5320",
  "hs-test-utils": "static-1.7716",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11151",
  "I18n": "static-7.1552",
  "jasmine-immutable": "static-1.2748",
  "jasmine-runner": "static-1.6185",
  "lodash": "static-1.3",
  "quartz": "static-1.6620",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16362",
  "reporting-data": "static-1.66252",
  "reporting-testing-lib": "static-1.8185",
  "reporting-visualizations": "static-1.58328",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4475",
  "webpack-env": "static-1.54",
  "atom": "static-1.4800",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2197",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.711",
  "customer-data-filters-ui": "static-1.38642",
  "customer-data-objects": "static-1.7348",
  "customer-data-property-utils": "static-1.7801",
  "data-fetching-client": "static-1.9406",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4261",
  "flux-actions": "static-1.301",
  "FormsCommonComponents": "static-1.85124",
  "FormUrlGenerator": "static-2.4461",
  "foundations-components": "static-1.7377",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11459",
  "icons": "static-2.617",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6873",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3590",
  "property-translator": "static-1.5144",
  "quartz-config": "static-1.398",
  "quartz-core": "static-1.5839",
  "quick-fetch": "static-1.3665",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5110",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7890",
  "reference-resolvers-lite": "static-1.7821",
  "report-customization-components": "static-1.12310",
  "reporting-enablement": "static-1.21864",
  "reporting-reports": "static-1.65930",
  "reporting-snowflake": "static-1.54870",
  "reporting-ui-components": "static-2.63524",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4338",
  "sales-content-partitioning": "static-1.8665",
  "SalesContentIndexUI": "static-3.8795",
  "sanitize": "static-1.4205",
  "sanitize-text": "static-1.7870",
  "self-service-api": "static-1.9958",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1467",
  "signup-constants": "static-1.18261",
  "signup-ui-lego-core": "static-1.20271",
  "signup-ui-url-generator": "static-2.7766",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4502",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10724",
  "ui-addon-i18n": "static-1.10859",
  "ui-addon-react-router-dom": "static-1.9277",
  "ui-addon-upgrades": "static-9.17495",
  "ui-asset-management-lib": "static-1.10610",
  "ui-images": "static-2.1072",
  "UIComponents": "static-3.8098",
  "usage-tracker": "static-1.7064",
  "usage-tracker-container": "static-1.7054",
  "usage-tracker-core": "static-1.6914",
  "usage-tracker-public": "static-1.6875",
  "viral-links-lib": "static-1.6754",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3163",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2897",
  "quartz-webpack": "static-1.2844",
  "ai-components-ui-library": "static-1.8180",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4561",
  "foundations-theming": "static-1.4134",
  "quartz-auth": "static-1.295",
  "usage-tracker-session-replay": "static-1.4750",
  "foundations-theming-base": "static-1.3119",
  "HeadJS": "static-2.698",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2827",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4060",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7654",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3396",
  "persist-promise": "static-1.3417",
  "reporting-client-types": "static-1.2359",
  "hs-story-utils": "static-1.9156",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9301",
  "hubspotter-http": "static-1.4415",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6978",
  "crm-message-bus": "static-1.42160",
  "customer-data-filters-ui-msw-helpers": "static-1.21076",
  "customer-data-objects-ui-components": "static-1.12733",
  "customer-data-reference-ui-components": "static-1.12869",
  "customer-data-ui-utilities": "static-1.9555",
  "framework-builder-read-service-client": "static-1.3784",
  "framework-data-schema-quick-fetch": "static-1.6503",
  "framework-data-schema-resolvers": "static-1.6598",
  "inbound-db-properties-service-client": "static-1.3615",
  "multi-account-reference-resolvers": "static-1.698",
  "onboarding-tours": "static-1.16171",
  "reporting-datasets-permissions-lib": "static-1.12865",
  "ui-addon-teams": "static-1.21137",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67438",
  "customer-data-properties": "static-1.50581",
  "forms-ai-lib": "static-1.3893",
  "forms-utils-lib": "static-1.12048",
  "foundations-components-test-utils": "static-1.4860",
  "react-dnd-compat": "static-1.4354",
  "react-tinymce": "static-1.54451",
  "tinymce-config": "static-2.53577",
  "ui-gdpr-components": "static-1.10075",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3646",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1017",
  "ui-fonts": "static-1.413",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.780",
  "mobile-manifest-mixins": "static-1.471",
  "quartz-head": "static-1.285",
  "quartz-i18n": "static-1.295",
  "quartz-routing": "static-1.50",
  "quartz-test": "static-1.295",
  "batch-promise": "static-1.1260",
  "external-options-client-types": "static-1.3919",
  "react-colorpicker": "static-2.9941",
  "copilot-toolkit": "static-1.10367",
  "data-quality-ui-library": "static-1.12170",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40464",
  "reporting-insights-lib": "static-1.978",
  "reporting-plugins": "static-1.9897",
  "ui-addon-draggable-compat": "static-2.3983",
  "ui-addon-opt": "static-4.8118",
  "ui-shepherd-react": "static-3.9874",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24544",
  "hubspot-apollo-client": "static-1.4610",
  "sales-templates-service-types-lib": "static-1.3929",
  "ui-business-units-lib": "static-1.8751",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5368",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3841",
  "upgrade-management-service-types": "static-1.4238",
  "timezone-utils": "static-2.4973",
  "bender-build-tools": "static-1.2859",
  "chatspot-core": "static-1.20077",
  "chirp-fetch": "static-1.1611",
  "bend-plugin-foundations-theming": "static-1.2617",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9299",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3560",
  "crm-pipelines-api-client-types": "static-1.3900",
  "multi-currency-client-types": "static-1.3454",
  "getting-started-shared-tasks": "static-1.17704",
  "growth-data-modal": "static-1.5064",
  "growth-onboarding-confetti": "static-1.2782",
  "growth-onboarding-next-action-utils": "static-1.1224",
  "navigation-components": "static-1.17070",
  "onboarding-tours-client": "static-1.4385",
  "onboarding-tours-utils": "static-1.237",
  "ui-shepherd-tracker": "static-1.7255",
  "ui-universal-auth": "static-1.8605",
  "user-context": "static-1.4824",
  "cms-field-types": "static-1.4537",
  "content-icons-ui": "static-1.2131",
  "integrations-lib": "static-1.15209",
  "calling-global-api": "static-1.63458",
  "calling-internal-common": "static-1.31021",
  "calling-lifecycle-internal": "static-1.64840",
  "calling-lifecycle-messages": "static-1.57134",
  "commerce-products-lib": "static-1.8656",
  "crm-links": "static-1.5982",
  "file-manager-components": "static-1.22696",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.394",
  "inbounddb-objects-service-types": "static-1.3987",
  "meetings-icalendar-utils-lib": "static-1.364",
  "object-builder-ui-client": "static-1.47765",
  "pipeline-validation-client-types": "static-1.3724",
  "property-value-citations": "static-1.1195",
  "pulse": "static-1.227",
  "smart-property-lib": "static-1.5663",
  "tiered-pricing": "static-1.724",
  "ui-addon-iframeable": "static-1.8750",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19345",
  "tinymce-themes": "static-1.55547",
  "data-token-picker": "static-1.15942",
  "hub-http-contrib": "static-1.2775",
  "interframe": "static-3.4522",
  "tinymce-data": "static-1.39662",
  "tinymce-plugins": "static-1.56691",
  "ui-addon-sales-email": "static-1.4943",
  "magpie-lib": "static-1.5305",
  "magpie-types": "static-1.4765",
  "simple-logging-lib": "static-1.2781",
  "content-assistance-lib": "static-1.7353",
  "dashboard-lib": "static-1.80363",
  "ExportDialog": "static-6.10116",
  "hubspot-prosemirror": "static-1.17427",
  "hubspot-prosemirror-plugins": "static-1.17419",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8419",
  "campaign-roi-lib": "static-1.8095",
  "feedback-loader": "static-1.28736",
  "onboarding-scopes": "static-1.6173",
  "apollo-link-hub-http": "static-2.4379",
  "hubspot-apollo-cache": "static-1.69",
  "growth-monetization-service-types": "static-1.4254",
  "nav-client-types": "static-1.2061",
  "purchase-motions-api": "static-1.5371",
  "trials-service-types": "static-1.3655",
  "chatspot-client-types": "static-1.10393",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.455",
  "getting-started-shared-tasks-store": "static-1.16822",
  "integrations-error-boundary-lib": "static-1.12624",
  "integrations-tracking-lib": "static-1.5313",
  "native-integrations-shared-strings": "static-1.7519",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10103",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31027",
  "shared-worker-versioning": "static-1.10746",
  "calling-usage-tracker": "static-1.6268",
  "calling-orchestration-shared-library": "static-1.34599",
  "voice-sms-access-library": "static-1.47",
  "customer-data-tracking": "static-1.6592",
  "products-iframe-lib": "static-1.7155",
  "products-ui-components-shared-msw-handlers": "static-1.9683",
  "location-customization-utils-lib": "static-1.8356",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3884",
  "video-components-external": "static-1.10357",
  "video-data-lib": "static-1.34015",
  "directed-graph": "static-1.665",
  "event-emitter": "static-1.655",
  "breeze-intelligence-kit": "static-1.5223",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9384",
  "fsm": "static-1.3461",
  "policy-lib": "static-1.6530",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9447",
  "navigation-messaging": "static-1.6397",
  "FileManagerLib": "static-1.38336",
  "NamespacedHubStyle": "static-2.8833",
  "FileManagerCore": "static-1.38195",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11916",
  "layout-dnd-utils": "static-1.10891",
  "react-codemirror": "static-1.10336",
  "ui-addon-emoji-picker": "static-1.9619",
  "ui-brand-identity-lib": "static-1.13544",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27774",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8296",
  "payment-link-components": "static-1.22758",
  "EmailSignatureEditor": "static-1.23821",
  "eligibility-engine-service-types": "static-1.2936",
  "universal-page-editor-lib": "static-1.2726",
  "calling-orchestration-schema": "static-1.34824",
  "sales-views-client-types": "static-1.4024",
  "crm-record-cards-service-types": "static-1.3387",
  "content-media-composition-data-lib": "static-1.11223",
  "content-media-compositions": "static-2.15230",
  "media-bridge-lib": "static-1.18465",
  "trellis-story-utils": "static-1.4252",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5518",
  "FileManagerImages": "static-1.35847",
  "video-components": "static-1.12360",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4263",
  "video-embed": "static-1.34849",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67513",
  "layout-data-lib": "static-1.9216",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6315",
  "commerce-tours-lib": "static-1.5614",
  "growth-onboarding-reliability": "static-1.4818",
  "sales-checkout-service-client": "static-1.3426",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21182",
  "sales-email-signature-service-client": "static-1.3573",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21157",
  "outpost": "static-1.3940",
  "advanced-menus-core": "static-1.14703",
  "advanced-menus-lib": "static-1.11692",
  "ui-memberships-settings-lib": "static-1.33256",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14702",
  "simple-menus-lib": "static-1.16219"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33821",
  "client-types": "/client-types/static-1.443",
  "documents-lib": "/documents-lib/static-1.33826",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1850",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5320",
  "hs-test-utils": "/hs-test-utils/static-1.7716",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11151",
  "I18n": "/I18n/static-7.1552",
  "jasmine-immutable": "/jasmine-immutable/static-1.2748",
  "jasmine-runner": "/jasmine-runner/static-1.6185",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6620",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16362",
  "reporting-data": "/reporting-data/static-1.66252",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8185",
  "reporting-visualizations": "/reporting-visualizations/static-1.58328",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4475",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4800",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2197",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.711",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38642",
  "customer-data-objects": "/customer-data-objects/static-1.7348",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7801",
  "data-fetching-client": "/data-fetching-client/static-1.9406",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4261",
  "flux-actions": "/flux-actions/static-1.301",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85124",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4461",
  "foundations-components": "/foundations-components/static-1.7377",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11459",
  "icons": "/icons/static-2.617",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6873",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3590",
  "property-translator": "/property-translator/static-1.5144",
  "quartz-config": "/quartz-config/static-1.398",
  "quartz-core": "/quartz-core/static-1.5839",
  "quick-fetch": "/quick-fetch/static-1.3665",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5110",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7890",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7821",
  "report-customization-components": "/report-customization-components/static-1.12310",
  "reporting-enablement": "/reporting-enablement/static-1.21864",
  "reporting-reports": "/reporting-reports/static-1.65930",
  "reporting-snowflake": "/reporting-snowflake/static-1.54870",
  "reporting-ui-components": "/reporting-ui-components/static-2.63524",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4338",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8665",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8795",
  "sanitize": "/sanitize/static-1.4205",
  "sanitize-text": "/sanitize-text/static-1.7870",
  "self-service-api": "/self-service-api/static-1.9958",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1467",
  "signup-constants": "/signup-constants/static-1.18261",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20271",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7766",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4502",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10724",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10859",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9277",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17495",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10610",
  "ui-images": "/ui-images/static-2.1072",
  "UIComponents": "/UIComponents/static-3.8098",
  "usage-tracker": "/usage-tracker/static-1.7064",
  "usage-tracker-container": "/usage-tracker-container/static-1.7054",
  "usage-tracker-core": "/usage-tracker-core/static-1.6914",
  "usage-tracker-public": "/usage-tracker-public/static-1.6875",
  "viral-links-lib": "/viral-links-lib/static-1.6754",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3163",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2897",
  "quartz-webpack": "/quartz-webpack/static-1.2844",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8180",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4561",
  "foundations-theming": "/foundations-theming/static-1.4134",
  "quartz-auth": "/quartz-auth/static-1.295",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4750",
  "foundations-theming-base": "/foundations-theming-base/static-1.3119",
  "HeadJS": "/HeadJS/static-2.698",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2827",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4060",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7654",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3396",
  "persist-promise": "/persist-promise/static-1.3417",
  "reporting-client-types": "/reporting-client-types/static-1.2359",
  "hs-story-utils": "/hs-story-utils/static-1.9156",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9301",
  "hubspotter-http": "/hubspotter-http/static-1.4415",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6978",
  "crm-message-bus": "/crm-message-bus/static-1.42160",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21076",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12733",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12869",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9555",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3784",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6503",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6598",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3615",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.698",
  "onboarding-tours": "/onboarding-tours/static-1.16171",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12865",
  "ui-addon-teams": "/ui-addon-teams/static-1.21137",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67438",
  "customer-data-properties": "/customer-data-properties/static-1.50581",
  "forms-ai-lib": "/forms-ai-lib/static-1.3893",
  "forms-utils-lib": "/forms-utils-lib/static-1.12048",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4860",
  "react-dnd-compat": "/react-dnd-compat/static-1.4354",
  "react-tinymce": "/react-tinymce/static-1.54451",
  "tinymce-config": "/tinymce-config/static-2.53577",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10075",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3646",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1017",
  "ui-fonts": "/ui-fonts/static-1.413",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.780",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.471",
  "quartz-head": "/quartz-head/static-1.285",
  "quartz-i18n": "/quartz-i18n/static-1.295",
  "quartz-routing": "/quartz-routing/static-1.50",
  "quartz-test": "/quartz-test/static-1.295",
  "batch-promise": "/batch-promise/static-1.1260",
  "external-options-client-types": "/external-options-client-types/static-1.3919",
  "react-colorpicker": "/react-colorpicker/static-2.9941",
  "copilot-toolkit": "/copilot-toolkit/static-1.10367",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12170",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40464",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.978",
  "reporting-plugins": "/reporting-plugins/static-1.9897",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3983",
  "ui-addon-opt": "/ui-addon-opt/static-4.8118",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9874",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24544",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4610",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3929",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8751",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5368",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3841",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4238",
  "timezone-utils": "/timezone-utils/static-2.4973",
  "bender-build-tools": "/bender-build-tools/static-1.2859",
  "chatspot-core": "/chatspot-core/static-1.20077",
  "chirp-fetch": "/chirp-fetch/static-1.1611",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2617",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9299",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3560",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3900",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3454",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17704",
  "growth-data-modal": "/growth-data-modal/static-1.5064",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2782",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1224",
  "navigation-components": "/navigation-components/static-1.17070",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4385",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.237",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7255",
  "ui-universal-auth": "/ui-universal-auth/static-1.8605",
  "user-context": "/user-context/static-1.4824",
  "cms-field-types": "/cms-field-types/static-1.4537",
  "content-icons-ui": "/content-icons-ui/static-1.2131",
  "integrations-lib": "/integrations-lib/static-1.15209",
  "calling-global-api": "/calling-global-api/static-1.63458",
  "calling-internal-common": "/calling-internal-common/static-1.31021",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64840",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57134",
  "commerce-products-lib": "/commerce-products-lib/static-1.8656",
  "crm-links": "/crm-links/static-1.5982",
  "file-manager-components": "/file-manager-components/static-1.22696",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.394",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3987",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.364",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47765",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3724",
  "property-value-citations": "/property-value-citations/static-1.1195",
  "pulse": "/pulse/static-1.227",
  "smart-property-lib": "/smart-property-lib/static-1.5663",
  "tiered-pricing": "/tiered-pricing/static-1.724",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8750",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19345",
  "tinymce-themes": "/tinymce-themes/static-1.55547",
  "data-token-picker": "/data-token-picker/static-1.15942",
  "hub-http-contrib": "/hub-http-contrib/static-1.2775",
  "interframe": "/interframe/static-3.4522",
  "tinymce-data": "/tinymce-data/static-1.39662",
  "tinymce-plugins": "/tinymce-plugins/static-1.56691",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4943",
  "magpie-lib": "/magpie-lib/static-1.5305",
  "magpie-types": "/magpie-types/static-1.4765",
  "simple-logging-lib": "/simple-logging-lib/static-1.2781",
  "content-assistance-lib": "/content-assistance-lib/static-1.7353",
  "dashboard-lib": "/dashboard-lib/static-1.80363",
  "ExportDialog": "/ExportDialog/static-6.10116",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17427",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17419",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8419",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8095",
  "feedback-loader": "/feedback-loader/static-1.28736",
  "onboarding-scopes": "/onboarding-scopes/static-1.6173",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4379",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.69",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4254",
  "nav-client-types": "/nav-client-types/static-1.2061",
  "purchase-motions-api": "/purchase-motions-api/static-1.5371",
  "trials-service-types": "/trials-service-types/static-1.3655",
  "chatspot-client-types": "/chatspot-client-types/static-1.10393",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.455",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16822",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12624",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5313",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7519",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10103",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31027",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10746",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6268",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34599",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.47",
  "customer-data-tracking": "/customer-data-tracking/static-1.6592",
  "products-iframe-lib": "/products-iframe-lib/static-1.7155",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9683",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8356",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3884",
  "video-components-external": "/video-components-external/static-1.10357",
  "video-data-lib": "/video-data-lib/static-1.34015",
  "directed-graph": "/directed-graph/static-1.665",
  "event-emitter": "/event-emitter/static-1.655",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5223",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9384",
  "fsm": "/fsm/static-1.3461",
  "policy-lib": "/policy-lib/static-1.6530",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9447",
  "navigation-messaging": "/navigation-messaging/static-1.6397",
  "FileManagerLib": "/FileManagerLib/static-1.38336",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8833",
  "FileManagerCore": "/FileManagerCore/static-1.38195",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11916",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10891",
  "react-codemirror": "/react-codemirror/static-1.10336",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9619",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13544",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27774",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8296",
  "payment-link-components": "/payment-link-components/static-1.22758",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23821",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2936",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2726",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34824",
  "sales-views-client-types": "/sales-views-client-types/static-1.4024",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3387",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11223",
  "content-media-compositions": "/content-media-compositions/static-2.15230",
  "media-bridge-lib": "/media-bridge-lib/static-1.18465",
  "trellis-story-utils": "/trellis-story-utils/static-1.4252",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5518",
  "FileManagerImages": "/FileManagerImages/static-1.35847",
  "video-components": "/video-components/static-1.12360",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4263",
  "video-embed": "/video-embed/static-1.34849",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67513",
  "layout-data-lib": "/layout-data-lib/static-1.9216",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6315",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5614",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4818",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3426",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21182",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3573",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21157",
  "outpost": "/outpost/static-1.3940",
  "advanced-menus-core": "/advanced-menus-core/static-1.14703",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11692",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33256",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14702",
  "simple-menus-lib": "/simple-menus-lib/static-1.16219"
}
};
